import { render, staticRenderFns } from "./MenuCardList.vue?vue&type=template&id=6538809e&scoped=true&"
import script from "./MenuCardList.vue?vue&type=script&lang=js&"
export * from "./MenuCardList.vue?vue&type=script&lang=js&"
import style0 from "./MenuCardList.vue?vue&type=style&index=0&id=6538809e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6538809e",
  null
  
)

export default component.exports